import React, { Component, Fragment, createElement } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { steps } from '../../statics';
import { history } from '../../../../../../config/history';
import { createOrderRequest } from '../../../redux/actions/create_order.actions';
import ShowBookingOrderStatus from './ShowBookingOrder';

const mapStateToProps = (state) => {
    const {
        tab, date_from, date_to, transport_date_data, date_type,
    } = state.Leads.Lead_profile.Lead_transport;
    const lead_id = state.Leads.Lead_profile.Lead_general.root_id;
    return {
        tab, date_from, date_to, transport_date_data, date_type, lead_id,
    };
};

export default connect(mapStateToProps, null)(class TransportModal extends Component {
  id = this.props.lead_id || history.location.pathname.slice(-24);

  state = {
      current: 0,
  };

  next = () => this.setState(state => ({ current: state.current + 1 }));

  prev = () => {
      this.setState(state => ({ current: state.current - 1 }),
          () => this.props.dispatch({ type: 'CLEAR_TRANSPORT_OPTIONS_DATE' }));
  };

  createOrderHandler = () => {
      this.props.dispatch(createOrderRequest(this.id, this.props.date_type, this.props.date_from, this.props.date_to));
  };

  render() {
      const { current } = this.state; const
          { date_from, date_to, transport_date_data } = this.props;
      return transport_date_data ? <ShowBookingOrderStatus />
          : (
              <Fragment>
                  {createElement(steps[current], this.props)}
                  <div className="steps-action-buttons">
                      {current === 1 && <Button style={{ marginRight: 8 }} onClick={this.prev}>Previous</Button>}
                      {current === 0
                          ? <Button disabled={this.props.tab === null} type="primary" onClick={this.next}>Next</Button>
                          : <Button disabled={!(date_from && date_to)} type="primary" onClick={this.createOrderHandler}>Create Order</Button>
                      }
                  </div>
              </Fragment>
          );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/TransportModalViews/TransportModal.js